<template>
  <div ref="wholesale-content" class="wholesale-content">
    <div class="content py-1 w-100 d-none d-sm-block" :class="{fixed:isFixed}">
      <div :class="{container:isFixed}" class="d-flex align-items-end justify-content-between justify-content-lg-end py-1">
        <jet-button v-if="account_balance > 0" btnStyle="primary" icon="fas fa-dollar-sign" class="pay-my-bill py-1 bar-button mr-lg-4" :goesTo="route('mtd.billing', 'charges')">Pay</jet-button>
        <ul class="nav-right navbar-nav align-items-baseline wholesale-link">
          <jet-dropdown  width="48">
            <template #trigger>
              <div class="wholesale-text wholesale-cart-button d-flex">
                Wholesale Cart
                <div class="position-relative ml-2">
                  <i class="fa fa-shopping-cart"></i>
                  <span class="badge badge-info badge-round text-white navbar-badge">{{ cart_items.length }}</span>
                </div>
              </div>
            </template>

            <template #content>
              <CartDropdown
                :items="cart_items"
                :routes="{
                  view: 'mtd.cart.view',
                  checkout: 'mtd.wholesale.checkout'
                }"
                :isWholesale="true" 
                :total="cart_total"
              />
            </template>
          </jet-dropdown>
        </ul>
        <jet-button type="button" class="bar-button view-cart" :goesTo="route('mtd.cart.view')">
          <div class="position-relative mr-3">
            <i class="fas fa-shopping-cart"></i>
            <span class="badge badge-bottom-bar badge-info badge-round text-white navbar-badge">{{ cart_items.length }}</span>
          </div>
          View Cart
        </jet-button>
        <jet-button :class="{disabled:!cart_items.length}" btnStyle="success" icon="fas fa-shopping-cart" class="py-1 ml-lg-4 ml-0 bar-button checkout-button" :goesTo="route('mtd.wholesale.checkout')">Checkout</jet-button>
      </div>
    </div>

    <div class="content py-1 w-100 d-sm-none" :class="{fixed:isFixed}">
      <div :class="{container:isFixed}" class="d-flex flex-column py-1">
        <jet-button v-if="account_balance > 0" btnStyle="primary" icon="fas fa-dollar-sign" class="pay-my-bill py-1 bar-button mr-lg-4 w-100 my-1" :goesTo="route('mtd.billing', 'charges')">Pay</jet-button>
        <ul class="nav-right navbar-nav align-items-baseline wholesale-link w-100 my-1">
          <jet-dropdown width="48" class="wholesale-cart">
            <template #trigger>
              <div class="wholesale-text wholesale-cart-button d-flex">
                Wholesale Cart
                <div class="position-relative ml-2">
                  <i class="fa fa-shopping-cart"></i>
                  <span class="badge badge-info badge-round text-white navbar-badge">{{ cart_items.length }}</span>
                </div>
              </div>
            </template>

            <template #content>
              <CartDropdown
                :items="cart_items"
                :routes="{
                  view: 'mtd.cart.view',
                  checkout: 'mtd.wholesale.checkout'
                }"
                :isWholesale="true"
                :total="cart_total"
              />
            </template>
          </jet-dropdown>
        </ul>
        <jet-button type="button" class="bar-button view-cart w-100 m-1" :goesTo="route('mtd.cart.view')">
          <div class="position-relative mr-3">
            <i class="fas fa-shopping-cart"></i>
            <span class="badge badge-bottom-bar badge-info badge-round text-white navbar-badge">{{ cart_items.length }}</span>
          </div>
          View Cart
        </jet-button>
        <jet-button :class="{disabled:!cart_items.length}" btnStyle="success" icon="fas fa-shopping-cart" class="py-1 ml-lg-4 ml-0 bar-button checkout-button w-100 m-1" :goesTo="route('mtd.wholesale.checkout')">Checkout</jet-button>
      </div>
    </div>
  </div>
</template>

<script>
  import JetDropdown from '@/Jetstream/Dropdown'
  import CartDropdown from '@/Components/Nav/CartDropdown'

  export default {
    components: {
      JetDropdown,
      CartDropdown
    },
    props: {
      cart_items: Array,
      cart_total: Number,
      account_balance: Number,
    },
    data() {
      return {
        isFixed: false
      }
    },
    mounted() {
      window.addEventListener('scroll', this.onScroll)
    },
    unmounted() {
      window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
      onScroll() {
        // TODO: fix this on tablet sized screens. The products disappear due to the "content" class on the first div within wholesale-content
        const target = this.$refs['wholesale-content']
        if (window.scrollY > (target.offsetTop)) {
          this.isFixed = true
        } else this.isFixed = false
      }
    }
  }
</script>
